module.exports = __webpack_public_path__ + "static/media/revista-junio2008.a78fe082.png";